















































































































import { Component, Prop, PropSync, Vue } from "vue-property-decorator";
import { AddOnServiceViewModel, AddOnServiceView } from "@/shared/models/addOnService";
import { ListModel } from "@/shared/models/listModel";
import { Action, Getter } from "vuex-class";
import { Currency } from "@/shared/models/currency";
import { TaxRateView } from "@/shared/models/taxRates";
import { PriceCalculationMethodView } from "@/shared/models/priceCalculationMethods";
import FormDescription from "@/components/misc/FormDescription.vue";
import RightDrawer from "@/components/misc/RightDrawer.vue";
import AddOnServicesAndFeesForm from "../AddOnServicesAndFeesForm.vue";

@Component({ components: { FormDescription, RightDrawer, AddOnServicesAndFeesForm } })
export default class AddOnServicesTable extends Vue {
  @PropSync("services") internalServices?: AddOnServiceViewModel[];
  @Prop() disabled?: boolean;
  @Prop({ default: false }) automaticallySetServices?: boolean;
  @Prop() readonly translateID?: string;
  @Prop() propertyId?: number;
  @Prop() accUnitId?: number;

  @Action("appParams/refreshAppParams") refreshAppParams?: () => Promise<void>;
  @Getter("appParams/tenantPaysVat") tenantPaysVat?: boolean;
   @Getter("appParams/tenantUsesOfficialRates")
  tenantUsesOfficialRates?: boolean;

  allItems: AddOnServiceView[] = [];
  formOpen = false;
  servicesFormOpen = false;

  created() {
    if(this.tenantPaysVat === undefined && this.refreshAppParams) {
      this.refreshAppParams();
    }
    if ((this.currencies?.length ?? 0) === 0 && this.refreshCurrencies) {
      this.refreshCurrencies();
    }
    if ((this.taxRates?.length ?? 0) === 0 && this.refreshTaxRates) {
      this.refreshTaxRates();
    }
    if (
      (this.priceCalculationMethods?.length ?? 0) === 0 &&
      this.refreshPriceCalculationMethods
    ) {
      this.refreshPriceCalculationMethods();
    }
    if (!this.tenantPaysVat) {
      this.headers = this.headers.filter((x) => x.value !== "netPrice");
      this.headers = this.headers.filter((x) => x.value !== "taxRateId");
    }
    if (this.tenantUsesOfficialRates){
      this.headers = this.headers.filter((x => x.value !== "select"));
    }
    this.load();
  }

  load(){
    this.axios
      .get<ListModel<AddOnServiceView>>("addOnServices", {
          params: {
            excludeBookingFee: true,
            $orderby: "name"
          },
        })
      .then(({ data }) => {
        this.allItems = data.result;

        if (this.automaticallySetServices) {
          const autoInternalServices = this.allItems
            .filter((x) => x.applyToAllProperties && !this.internalServices?.map(s => s.addOnServiceId).includes(x.id))
            .map((x) => { return { addOnServiceId: x.id, mergeToAccommodationWhenInvoicing: false } as AddOnServiceViewModel });
          
          if(this.internalServices)
          {
            this.internalServices.push(...autoInternalServices);
          }
          else {
            this.internalServices = autoInternalServices;
          }
        }
      });
  }

  get items() {
    return this.allItems.filter((i) =>
      this.internalServices?.some((s) => i.id === s.addOnServiceId)
    );
  }
  get pickableItems() {
    return this.allItems.filter(
      (i) => !this.internalServices?.some((s) => i.id === s.addOnServiceId)
    );
  }

  headers = [
    { text: "AddOnService.Name", value: "name" },
    { text: "AddOnService.NetPrice", value: "netPrice" },
    { text: "AddOnService.TaxRate", value: "taxRateId" },
    { text: "AddOnService.GrossPrice", value: "grossPrice" },
    { text: "AddOnService.CalculationMethod", value: "calculationMethodId" },
    { text: "AddOnService.MergeToAcc", value: "select" },
    { text: "", value: "actions" },
  ];

  // prettier-ignore
  @Action("codebooks/refreshCurrencies") refreshCurrencies?: () => Promise<void>;
  @Getter("codebooks/currencies") currencies?: Currency[];
  @Action("codebooks/refreshTaxRates") refreshTaxRates?: () => Promise<void>;
  @Getter("codebooks/taxRates") taxRates?: TaxRateView[];
  @Action("codebooks/refreshPriceCalculationMethods")
  refreshPriceCalculationMethods?: () => Promise<void>;
  @Getter("codebooks/priceCalculationMethods")
  priceCalculationMethods?: PriceCalculationMethodView[];

  taxRateDisplay(taxRateId: number) {
    const rate = this.taxRates?.find((tr) => tr.id === taxRateId);
    return rate ? this.$t(rate.textResourceKey) : "";
  }

  priceCalculationMethodDisplay(priceCalculationMethodId: number) {
    const pcm = this.priceCalculationMethods?.find(
      (tr) => tr.id === priceCalculationMethodId
    );
    return pcm ? this.$t(pcm.textResourceKey) : "";
  }

  currencyDisplay(amount: number, currencyId: number) {
    const currency = this.currencies?.find((c) => c.id === currencyId);
    return currency
      ? this.$n(amount, {
          style: "currency",
          currency: currency.isoCode,
          currencyDisplay: "code",
        })
      : "";
  }

  isSelected(item: any)
  {
    if (this.internalServices) {
      const changed = this.internalServices.findIndex((s) => s.addOnServiceId === item.id);
      if(changed !== -1) {
         return this.internalServices[changed].mergeToAccommodationWhenInvoicing;
      }
    }

    return false;
  }

  select(item: any, isSelected: boolean) {
    if (this.internalServices) {
      const changed = this.internalServices.findIndex((s) => s.addOnServiceId === item.id);
      if(changed !== -1) {
        this.internalServices[changed].mergeToAccommodationWhenInvoicing = isSelected;
      }
    }
  }

  add() {
    this.formOpen = true;
    this.pickedServices = [];
  }

  pickedServices: number[] = [];
  submit() {
    if (this.internalServices) {
      const autoInternalServices = this.pickedServices
            .map((x) => { return { addOnServiceId: x, mergeToAccommodationWhenInvoicing: false } as AddOnServiceViewModel });
      this.$emit("update:services", [
        ...this.internalServices,
        ...autoInternalServices,
      ]);
    }
    this.pickedServices = [];
    this.formOpen = false;
  }

  removeService(item: AddOnServiceView) {
    if (this.internalServices) {
      this.$emit(
        "update:services",
        this.internalServices.filter((x) => x.addOnServiceId !== item.id)
      );
    }
  }

  serviceAdded(){
    this.load();
    this.servicesFormOpen = false;
    this.formOpen = false;
    this.$emit('serviceAdded')
  }
}
